import axios from 'axios';
import { caseStudies, getCaseStudyBySlug } from '@/data/caseStudies';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000').replace(/\/$/, '');
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = () => {
  const token = localStorage.getItem('r360_admin_token');
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const postDemoRequest = (data) => api.post('/demo-requests', data).then((r) => r.data);
export const postNewsletter = (email) => api.post('/newsletter', { email }).then((r) => r.data);
export const postCalculator = (payload) => api.post('/calculator', payload).then((r) => r.data);
export const fetchCaseStudies = () =>
  api
    .get('/case-studies')
    .then((r) => (Array.isArray(r.data) ? r.data : caseStudies))
    .catch(() => caseStudies);

export const fetchCaseStudy = (slug) =>
  api
    .get(`/case-studies/${slug}`)
    .then((r) => r.data)
    .catch(() => {
      const study = getCaseStudyBySlug(slug);
      if (!study) throw new Error('Case study not found');
      return study;
    });

export const adminLogin = (password) => api.post('/admin/login', { password }).then((r) => r.data);
export const adminVerify = () => adminApi().get('/admin/verify').then((r) => r.data);
export const adminStats = () => adminApi().get('/admin/stats').then((r) => r.data);
export const adminListDemos = () => adminApi().get('/admin/demo-requests').then((r) => r.data);
export const adminListNewsletter = () => adminApi().get('/admin/newsletter').then((r) => r.data);
